<script setup lang="ts">
defineProps({
  overlay: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="stack-wrapper">
    <div class="stack-container main-image" :class="{ 'with-overlay': overlay }">
      <slot name="main" />
    </div>
    <div class="stack-container secondary-image">
      <slot name="secondary" />
    </div>
    <div class="stack-container tertiary-image">
      <slot name="tertiary" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.stack-wrapper {
  position: relative;
  width: calc(100% - 9rem);
  height: 30rem; /* Adjust as needed */
}

.stack-container {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

.main-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.secondary-image {
  position: absolute;
  top: 1rem;
  left: 4rem;
  width: 100%;
  height: calc(100% - 2rem);
  z-index: 2;
}

.tertiary-image {
  position: absolute;
  top: 2rem;
  left: 8rem;
  width: 100%;
  height: calc(100% - 4rem);
  z-index: 1;
}

.with-overlay {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%);
  z-index: 2;
}

/* Ensure images fill their containers */
.stack-container :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
